var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.841797,
    width: 50,
    height: 50,
    rx: 6,
    fill: "#A3A3A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8444 24.9987L9.17773 8.33203M25.8444 24.9987L42.5111 8.33203M25.8444 24.9987L9.17773 41.6654M25.8444 24.9987L42.5111 41.6654M9.17773 8.33203V16.6654M9.17773 8.33203H17.5111M42.5111 8.33203V16.6654M42.5111 8.33203H34.1777M9.17773 41.6654V33.332M9.17773 41.6654H17.5111M42.5111 41.6654V33.332M42.5111 41.6654H34.1777",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag-and-drop.486c1f0eb898f9996b658facd0cf25a2.svg";
export { ForwardRef as ReactComponent };